module.exports = __webpack_public_path__ + "img/08.f323c688.png";